import _defineProperty from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { createContext } from 'react';
import { getDefaults, setDefaults } from './defaults.js';
import { getI18n, setI18n } from './i18nInstance.js';
import { initReactI18next } from './initReactI18next.js';
export { getDefaults, setDefaults, getI18n, setI18n, initReactI18next };
export var I18nContext = createContext();
export var ReportNamespaces = /*#__PURE__*/function () {
  function ReportNamespaces() {
    _classCallCheck(this, ReportNamespaces);
    this.usedNamespaces = {};
  }
  _createClass(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;
      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);
  return ReportNamespaces;
}();
export var composeInitialProps = function composeInitialProps(ForComponent) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ctx) {
      var _yield$ForComponent$g, _ForComponent$getInit;
      var componentsInitialProps, i18nInitialProps;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (_ForComponent$getInit = ForComponent.getInitialProps) === null || _ForComponent$getInit === void 0 ? void 0 : _ForComponent$getInit.call(ForComponent, ctx);
            case 2:
              _context.t1 = _yield$ForComponent$g = _context.sent;
              _context.t0 = _context.t1 !== null;
              if (!_context.t0) {
                _context.next = 6;
                break;
              }
              _context.t0 = _yield$ForComponent$g !== void 0;
            case 6:
              if (!_context.t0) {
                _context.next = 10;
                break;
              }
              _context.t2 = _yield$ForComponent$g;
              _context.next = 11;
              break;
            case 10:
              _context.t2 = {};
            case 11:
              componentsInitialProps = _context.t2;
              i18nInitialProps = getInitialProps();
              return _context.abrupt("return", _objectSpread(_objectSpread({}, componentsInitialProps), i18nInitialProps));
            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var getInitialProps = function getInitialProps() {
  var _i18n$reportNamespace, _i18n$reportNamespace2;
  var i18n = getI18n();
  var namespaces = (_i18n$reportNamespace = (_i18n$reportNamespace2 = i18n.reportNamespaces) === null || _i18n$reportNamespace2 === void 0 ? void 0 : _i18n$reportNamespace2.getUsedNamespaces()) !== null && _i18n$reportNamespace !== void 0 ? _i18n$reportNamespace : [];
  var ret = {};
  var initialI18nStore = {};
  i18n.languages.forEach(function (l) {
    initialI18nStore[l] = {};
    namespaces.forEach(function (ns) {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
};